import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/steps-to-miles-calculator',
  component: () => import('../../routes/StepsToMilesCalculator.svelte'),
  card: {
    id: 'steps-to-miles-calculator',
    title: 'Steps to Miles & Calories',
    description:
      'Convert steps to miles, kilometers, and calories burned. Works for both walking and running, with height- and sex-based stride length. Includes pace, speed, and time estimates.',
    icon: 'directions_walk',
    iconBgClass: 'bg-rose-50',
    iconTextClass: 'text-rose-600',
    href: '/steps-to-miles-calculator',
    category: 'Health & Fitness',
  },
  seo: {
    title: 'Steps to Miles Calculator — Walking, Running & Calories',
    description:
      'Free steps-to-miles calculator. Convert step count to miles, kilometers, walking time, and calories burned. Uses height-based stride length (Tudor-Locke 2002) and MET-based calorie formula (2011 Compendium of Physical Activities).',
  },
};

export default meta;
